import { z } from "zod";
import { ReportIdSchema } from "../primitives/ids.js";
import { PublicScanTopIssueV1Schema } from "./public-scan.js";
/** Sentinel project id for agency-level public scan opportunity audit events. */
export const PUBLIC_SCAN_OPPORTUNITY_PROJECT_ID = "public_scan_opportunity";
export const AGENCY_UNLOCK_TIERS = ["FREE_PREVIEW", "FULL_DETAIL_LOCKED"];
export const AgencyUnlockTierSchema = z.enum(AGENCY_UNLOCK_TIERS);
export const ClaimIdSchema = z
    .string()
    .regex(/^claim_[a-zA-Z0-9_-]+$/)
    .brand();
/** Agency-only opportunity view — client-safe fields only (no internal scan JSON). */
export const AgencyPublicScanOpportunityV1Schema = z
    .object({
    schemaVersion: z.literal("agency-public-scan-opportunity.v1.0"),
    claimId: ClaimIdSchema,
    publicReportRef: ReportIdSchema,
    scannedUrl: z.string().url(),
    score: z.number().int().min(0).max(100),
    scoreLabel: z.string().min(1),
    topIssues: z.array(PublicScanTopIssueV1Schema).max(5),
    unlockTier: AgencyUnlockTierSchema,
    fullDetailUnlocked: z.boolean(),
    opportunityStatus: z.literal("CLAIMED"),
    nextAction: z.string().min(1),
    claimedAt: z.string().datetime(),
})
    .strict();
/** POST /v1/agencies/:agencyId/public-reports/:publicReportRef/claim response. */
export const PublicReportClaimResultV1Schema = z
    .object({
    schemaVersion: z.literal("public-report-claim-result.v1.0"),
    claimId: ClaimIdSchema,
    publicReportRef: ReportIdSchema,
    unlockTier: z.literal("FREE_PREVIEW"),
    fullDetailUnlocked: z.literal(false),
    claimedAt: z.string().datetime(),
    idempotentReplay: z.boolean(),
    opportunity: AgencyPublicScanOpportunityV1Schema,
})
    .strict();
export const AgencyPublicScanOpportunityListV1Schema = z
    .object({
    schemaVersion: z.literal("agency-public-scan-opportunity-list.v1.0"),
    opportunities: z.array(AgencyPublicScanOpportunityV1Schema),
})
    .strict();
export const AGENCY_OPPORTUNITY_NEXT_ACTION_PREVIEW = "Review the score and top issues, then reach out to the site owner. Full detail unlock is not available in this release.";
export const AGENCY_OPPORTUNITY_NEXT_ACTION_FULL = "Full detail is unlocked — review all issues and plan remediation.";
//# sourceMappingURL=agency-unlock.js.map